/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Uzavřeno`
};

const da_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Lukket`
};

const de_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Geschlossen`
};

const en_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Closed`
};

const es_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrado`
};

const fr_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Fermée`
};

const hu_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Lezárva`
};

const it_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Chiuso`
};

const nl_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Gesloten`
};

const pl_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Zamknięte`
};

const pt_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Fechado`
};

const sv_order_states_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Stängd`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_states_closed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_states_closed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_states_closed", locale)
	if (locale === "cs") return cs_order_states_closed(inputs)
	if (locale === "da") return da_order_states_closed(inputs)
	if (locale === "de") return de_order_states_closed(inputs)
	if (locale === "en") return en_order_states_closed(inputs)
	if (locale === "es") return es_order_states_closed(inputs)
	if (locale === "fr") return fr_order_states_closed(inputs)
	if (locale === "hu") return hu_order_states_closed(inputs)
	if (locale === "it") return it_order_states_closed(inputs)
	if (locale === "nl") return nl_order_states_closed(inputs)
	if (locale === "pl") return pl_order_states_closed(inputs)
	if (locale === "pt") return pt_order_states_closed(inputs)
	return sv_order_states_closed(inputs)
};
export { order_states_closed as "order_states.closed" }